import {useTitle} from 'hooks';
import {NavbarCommon} from 'components';
import FormSignUp from './components/Form.SignUp';

interface IPageSignUpProps {}

const PageSignUp = ({}: IPageSignUpProps) => {
  useTitle('Sign Up');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <FormSignUp />
    </div>
  );
};

export default PageSignUp;
